// @flow
export const MIN_ADULTS = 1;
export const MIN_BEDROOMS = 0;
export const MAX_BEDROOMS = 50;
export const MIN_BATHROOMS = 0;
export const MAX_BATHROOMS = 50;
export const MIN_PRICE = 0;
export const MAX_PRICES = {
    USD: 1000, // US Dollar
    EUR: 1000, // Euro
    GBP: 1000, // British Pound Sterling
    CAD: 1500, // Canadian dollar
    MXN: 20000, // Mexican peso
    ARS: 40000, // Argentine peso
    AUD: 1500, // Australian dollar
    BRL: 4000, // Brazilian Real
    CHF: 1000, // Swiss Franc
    CNY: 7000, // Chinese Yuan
    COP: 3000000, // Columbian Peso
    CZK: 20000, // Czech Koruna
    DKK: 7000, // Danish Krone
    HKD: 8000, // Hong Kong dollar
    HRK: 7000, // Croatian Kuna
    HUF: 300000, // Hungarian Forint
    IDR: 15000000, // Indonesian Rupiah
    ILS: 4000, // Israeli New Sheqel
    INR: 70000, // Indian Rupee
    JPY: 100000, // Japanese Yen
    KRW: 1000000, // South Korean Won
    MYR: 4000, // Malaysian Ringgit
    NOK: 9000, // Norwegian Krone
    NZD: 1500, // New Zealand Dollar
    PLN: 4000, // Polish Zloty
    RUB: 70000, // Russian Ruble
    SEK: 10000, // Swedish Krona
    SGD: 1500, // Singapore dollar
    THB: 30000, // Thai Baht
    TRY: 5000, // Turkish Lira
    ZAR: 15000, // South African Rand
    DEFAULT: 1000,
    UNLIM: 3000000000 // is used when HA_SERP_MIN_MAX_PRICE_FIELDS is V2, value from GT
};

export const MIN_ALLOWED_WINDOW_HEIGHT_FOR_MODAL_FIXED_CTA = 400;
export const MULTIPLE_UNITS_DROPDOWN_HEIGHT = 288;
export const PAGE_NUMBER = 1;
export const PAGE_SIZE = 50;
export const SORT_PARAM = 'PRICE_ASC';
